export enum Text {
  Proceed = 'Proceed',
  Decline = 'Decline',
  DeclineAllOffers = 'Decline All Offers',
  CashToYou = 'Cash to You',
}
